import countBy from 'lodash/countBy';
import {
  IrrelevantApp,
  RawIrrelevantApp,
  ReasonFilter,
} from '../irrelevant-apps-types';
import { ReasonFilter as Filters } from '../stores/reason-filters-store';

const createIrrelevantAppsInfo = (
  data: RawIrrelevantApp[],
): {
  result: IrrelevantApp[];
  filters: ReasonFilter[];
} => {
  const result = data
    .sort((a, b) => {
      const date1 = new Date(Number(b.lastCodeChange));
      const date2 = new Date(Number(a.lastCodeChange));
      return date1.valueOf() - date2.valueOf();
    })
    .map(app => ({
      appId: app.appId,
      name: app.appName,
      reasons: [...new Set(app.irrelevantReasons?.slice(0, 3))] || [],
      lastCodeChange: app.lastCodeChange,
      overrideRelevance: app.overrideRelevance,
      type: app.type,
      fakeApp: app.fakeApp,
    }));

  // all reasons
  const allReasonsArr = Array.from(Object.keys(Filters).flat());

  // results reasons
  const reasonsArr = Array.from(result.map(r => r.reasons).flat());

  // add missing reasons with count:0
  const allReasons = [...allReasonsArr, ...reasonsArr];

  const countersObj = countBy(allReasons);

  const filters: ReasonFilter[] = Object.entries(countersObj).map(([k, v]) => ({
    reason: k,
    count: v - 1,
  }));

  return { result, filters };
};

export default createIrrelevantAppsInfo;
